/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PayWithSbpRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PayWithSbpRequest(value) {
    if (!('PublicId' in value) || value['PublicId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreBank131PayWithSbpRequestFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithSbpRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithSbpRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PublicId': json['PublicId'],
    };
}
export function FxIdWebFeaturesStoreBank131PayWithSbpRequestToJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithSbpRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithSbpRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PublicId': value['PublicId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PayWithSbpRequest.js.map